export default {
      id: "icon-predictions-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-predictions",
      toString: function () {
        return this.url;
      }
    }